import React, { useState } from 'react'
import Sidebar from '../SideBar/index'
import Index2 from '../Navbar2/index2'
import "./Hero4.css"

const HeroSection2 = () => {
  const [isOpen, setIsOpen] = useState(false)
  
  const toggle = () => {
    setIsOpen(!isOpen)
  }
  return (
    <div className='HeroContainer'>
      <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='HeroBg4'>
          <Index2 toggle={toggle}/>
        </div>
    </div>
  )
}

export default HeroSection2